import EmptyTemplate from '../empty-result/empty-result.twig';
import NewsTemplate from '../../sections/news-list/templates/news-list.twig';
import {Utils} from '../../common/scripts/utils';

class YearsList {
    constructor(options) {
        this.template = '';
        this.button = options.button;
        this.moreButton = options.moreButton || null;
        this.wrapper = options.wrapper;
        this.itemClass = options.itemClass;
        this.contentWrapper = options.contentWrapper;
        this.activeClass = 'is-active';
        this.page = options.page;
        this.url = options.url;
        this.tags = options.tags || false;
        this.tagsItem = options.tagsItem || null;
        this.search = options.search || null;
        this.searchField = options.searchField || null;
    }

    /**
     * Инициализация экземпляра класса
     * @public
     */
    init() {
        this._bindEvents();
    }

    _bindEvents() {
        window.addEventListener('click', (event) => {
            this._clickOutside(event);
        });
        this.button.addEventListener('click', () => {
            if (Utils.getWindowWidth() < 670) {
                if (this.wrapper.classList.contains('is-active')) {
                    Utils.bodyStatic();

                    return;
                }

                Utils.bodyFixed(this.wrapper);
            }

            this.wrapper.classList.toggle('is-active');
            this.button.classList.toggle('is-opened');
        });

        const allYears = Array.from(this.wrapper.querySelectorAll(this.itemClass));

        allYears.forEach((year) => {
            year.addEventListener('click', () => {
                if (!year.classList.contains('is-active')) {
                    this._bindYear(year, allYears);

                    this._closeFilter();
                }
            });
        });

        // Закрываем фильтр по годам на мобильных
        const mobileClose = document.querySelector('.j-years-close');

        if (mobileClose) {
            mobileClose.addEventListener('click', this._closeFilter.bind(this));
        }
    }

    /**
     * Ловит клик снаружи элемента
     * @param {object} event - объект события клика
     * @private
     */
    _clickOutside(event) {
        if (!event && !event.target) {
            return;
        }

        if (!Utils.closest(event.target, this.button.parentElement)) {
            this.wrapper.classList.remove('is-active');
            this.button.classList.remove('is-opened');
        }
    }

    /**
     *
     * @param {object} year - HTML элемент нажатой кнопки года
     * @param {array} allYears - массив всех доступных годов
     * Обрабатываем событие нажатия на год в фильтре
     */
    _bindYear(year, allYears) {
        const yearText = year.querySelector('.button__text').innerText;

        allYears.forEach((item) => {
            if (item.classList.contains(this.activeClass)) {
                item.classList.remove(this.activeClass);
            }
        });

        year.classList.toggle(this.activeClass);

        // Устанавливаем выбранный вариант в селект
        this.button.querySelector('.button__text').innerText = yearText;

        this._sendRequest(year.dataset.year);
    }

    /**
     *
     * @param {string} year - выбранный год
     *
     */
    _sendRequest(year) {
        const that = this;
        const tagsData = [];
        let searchData = '';

        // Если есть теги то передаем и их в запрос
        if (this.tags) {
            const allTags = Array.from(this.tags.querySelectorAll(this.tagsItem));

            const filteredTags = allTags.filter((tag) => {
                return tag.classList.contains(this.activeClass);
            });

            if (filteredTags.length) {
                filteredTags.forEach((item) => {
                    tagsData.push(item.dataset.tag);
                });
            }
        }

        if (this.search.classList.contains('is-searched') && this.searchField) {
            searchData = this.search.querySelector(this.searchField).value;
        }


        const formData = this._createFormData(tagsData, year, searchData);

        Utils.send(formData, that.url, {
            success(response) {
                const {data} = response;

                that._setTemplate(data.items);

                that._checkMore(data.more);

                Utils.clearHtml(that.contentWrapper);

                that._insertItems(data);
            }
        }, 'POST');
    }

    /**
     * Формирует объект FormData
     * @param {array} tagsData - массив данных
     * @param {array} year - переменная
     * @param {text} searchData - текст поисковой строки
     * @returns {object} - возвращает сформированный объект FormData
     */
    _createFormData(tagsData, year, searchData) {
        const formData = new FormData();

        if (tagsData.length) {
            formData.append('tags', tagsData);
        } else {
            formData.append('tags', []);
        }

        formData.append('search', searchData);

        formData.append('year', year);

        // Сбрасываем на 0 количество показанных новостей при смене года
        formData.append('count', 0);
        formData.append('page', this.page);

        return formData;
    }

    _setTemplate(items) {
        const that = this;

        if (items.length === 0) {
            this.template = EmptyTemplate;
        } else if (that.page === 'news') {
            this.template = NewsTemplate;
        }
    }

    // Закрывает плашку фильтра годов на мобильных
    _closeFilter() {
        if (this.wrapper.classList.contains('is-active')) {
            this.wrapper.classList.remove('is-active');
        }

        if (this.button.classList.contains('is-opened')) {
            this.button.classList.remove('is-opened');
        }

        Utils.bodyStatic();
    }

    _checkMore(more) {
        if (this.moreButton.dataset.page) {
            this.moreButton.dataset.page = 2;
        }

        this.moreButton.style.display = more ? 'inline-flex' : 'none';
    }

    /**
     * Вставляет новые элементы в контейнер
     * @param {object} data - данные для заполнения шаблона
     * @private
     */
    _insertItems(data) {
        this.contentWrapper.insertAdjacentHTML('beforeend', this.template(data));
    }
}

export default YearsList;
